import React from 'react';
import { Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import MapsUgcOutlinedIcon from '@mui/icons-material/MapsUgcOutlined';
import { useUntypedTranslation } from '../../hooks/useUntypedTranslation';
import styles from './ChatPage.module.scss';

interface ChatHeaderProps {
  toggleHistoryMobile: () => void;
  handleNewChat: () => void;
}

const ChatHeader: React.FC<ChatHeaderProps> = ({ toggleHistoryMobile, handleNewChat }) => {
  const { t } = useUntypedTranslation();
  // Check for mobile using a media query (here: max-width of 768px)
  const isMobile = useMediaQuery('(max-width:768px)');

  // If not mobile, render nothing.
  if (!isMobile) return null;

  return (
    <Box
      className={styles.chatWindowHeaderMobile}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        padding: '0 8px',
        borderBottom: '1px solid #dcd8d3',
        marginTop: '-7px',
      }}
    >
      <Box
        onClick={toggleHistoryMobile}
        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
      >
        <IconButton edge="start" color="inherit" aria-label="menu" sx={{ ml: -1 }}>
          <HistoryIcon />
        </IconButton>
        <Typography variant="body1" sx={{ ml: 1 }}>
          History
        </Typography>
      </Box>
      <Box
        onClick={handleNewChat}
        sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
      >
        <Typography variant="body1" sx={{ mr: 1 }}>
          {t('chat.startNewConversation', 'Start New Conversation')}
        </Typography>
        <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: -1 }}>
          <MapsUgcOutlinedIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ChatHeader;
